// extracted by mini-css-extract-plugin
export default {"sendReviewButton":"PostReview_sendReviewButton__GHPEE","overlay":"PostReview_overlay__zKX7w"};